import PropTypes from 'prop-types';
import React from 'react';
import { getContentUrl } from '../../utils/contentoUtils.js';
import ShowcaseCard from '../ShowcaseCard/ShowcaseCard.jsx';
import { GridContainer, StyledShowcase } from './Showcase.styles';
import { Heading } from 'app/components/Recommendations/Recommendations.styles.js';

const Showcase = ({
    items,
    onItemClick,
    currentAccessibilityChoiceContento,
    className,
    addBottomMargin = false,
    header = '',
    isDisplaywindow,
    id,
}) => {
    return (
        <StyledShowcase
            className={className}
            data-helix-type="list"
            aria-label={!isDisplaywindow ? header || 'Rekommenderat' : ''}
            addBottomMargin={addBottomMargin}
            isDisplaywindow={isDisplaywindow}
        >
            {!isDisplaywindow && <Heading as="h2">{header}</Heading>}
            <GridContainer>
                {items.map((item, index) => {
                    const url = getContentUrl(item.item, currentAccessibilityChoiceContento);

                    return (
                        <ShowcaseCard
                            key={index}
                            item={item}
                            url={url}
                            index={index}
                            onItemClick={onItemClick}
                            listId={id}
                        />
                    );
                })}
            </GridContainer>
        </StyledShowcase>
    );
};

Showcase.propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentAccessibilityChoiceContento: PropTypes.string,
    onItemClick: PropTypes.func,
};

export default Showcase;
